import React from "react";
import { Award, Star, Users, CheckCircle } from "lucide-react";
import Nilesh from "../../../assets/nilesh.jpeg";
const PriestSection = () => {
  return (
    <section className="py-12 md:py-16 px-4 bg-white">
      <div className="container mx-auto max-w-6xl">
        <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          {/* Left Side - Priest Information */}
          <div className="order-2 lg:order-1">
            <div className="mb-4 md:mb-6">
              <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-2 md:mb-4">
                Meet Shreepujak
              </h2>
            </div>

            <div className="space-y-4 md:space-y-6">
              <div className="bg-gradient-to-br from-orange-50 to-red-50 rounded-xl p-4 md:p-6 border border-orange-100">
                <h3 className="text-xl md:text-2xl font-bold text-gray-800 mb-2">
                  Nilesh Vidyadhar Thanekar
                </h3>
                <p className="text-orange-600 font-semibold mb-3">Shreepujak</p>
                <p className="text-gray-600 leading-relaxed text-sm md:text-base">
                  With over many years of dedicated service to Shree Mahalaxmi
                  Ambabai, Nilesh Vidyadhar Thanekar brings profound spiritual
                  wisdom and authentic Vedic knowledge to every ceremony. He is
                  hereditary Shreepujak of Mahalaxmi Ambabai Devi. His deep
                  understanding of ancient Sanskrit texts and traditional
                  rituals ensures that each puja is performed with utmost
                  devotion and precision.
                </p>
              </div>

              {/* <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 md:gap-4">
                <div className="bg-white rounded-lg p-3 md:p-4 border border-gray-200 shadow-sm">
                  <div className="flex items-center mb-2">
                    <Award className="h-4 w-4 md:h-5 md:w-5 text-orange-500 mr-2" />
                    <span className="font-semibold text-gray-800 text-sm md:text-base">
                      Experience
                    </span>
                  </div>
                  <p className="text-gray-600 text-sm md:text-base">
                    20+ Years in Temple Service
                  </p>
                </div>

                <div className="bg-white rounded-lg p-3 md:p-4 border border-gray-200 shadow-sm">
                  <div className="flex items-center mb-2">
                    <Star className="h-4 w-4 md:h-5 md:w-5 text-orange-500 mr-2" />
                    <span className="font-semibold text-gray-800 text-sm md:text-base">
                      Specialization
                    </span>
                  </div>
                  <p className="text-gray-600 text-sm md:text-base">
                    Vedic Rituals & Sanskrit
                  </p>
                </div>

                <div className="bg-white rounded-lg p-3 md:p-4 border border-gray-200 shadow-sm">
                  <div className="flex items-center mb-2">
                    <Users className="h-4 w-4 md:h-5 md:w-5 text-orange-500 mr-2" />
                    <span className="font-semibold text-gray-800 text-sm md:text-base">
                      Devotees Served
                    </span>
                  </div>
                  <p className="text-gray-600 text-sm md:text-base">
                    Over 2 Lakh Families
                  </p>
                </div>

                <div className="bg-white rounded-lg p-3 md:p-4 border border-gray-200 shadow-sm">
                  <div className="flex items-center mb-2">
                    <CheckCircle className="h-4 w-4 md:h-5 md:w-5 text-orange-500 mr-2" />
                    <span className="font-semibold text-gray-800 text-sm md:text-base">
                      Hereditary Line
                    </span>
                  </div>
                  <p className="text-gray-600 text-sm md:text-base">
                    54th Generation
                  </p>
                </div>
              </div> */}

              <div className="bg-blue-50 border border-blue-200 rounded-lg p-3 md:p-4">
                <p className="text-blue-800 italic leading-relaxed text-sm md:text-base">
                  "Every puja is a sacred connection between the devotee and the
                  divine. I consider myself blessed to be a medium for these
                  divine blessings and ensure that each ritual carries the pure
                  intentions and prayers of our devotees to Mahalaxmi Ambabai
                  Mata."
                </p>
                <p className="text-blue-700 font-semibold mt-2 text-sm md:text-base">
                  - Shreepujak Nilesh Vidyadhar Thanekar
                </p>
              </div>
            </div>
          </div>

          {/* Right Side - Priest Image */}
          <div className="relative order-1 lg:order-2">
            <div className="bg-gradient-to-br from-orange-100 to-red-100 rounded-2xl p-4 md:p-8">
              <div className="relative">
                <img
                  src={Nilesh}
                  alt="Nilesh Thanekar - Shreepujak"
                  className="w-full h-64 sm:h-80 md:h-96 rounded-xl object-cover shadow-lg"
                />
                <div className="absolute -bottom-2 -right-2 md:-bottom-4 md:-right-4 bg-white rounded-full p-2 md:p-4 shadow-lg">
                  <div className="w-8 h-8 md:w-12 md:h-12 bg-gradient-to-r from-orange-500 to-red-500 rounded-full flex items-center justify-center text-white text-lg md:text-2xl">
                    🙏
                  </div>
                </div>
              </div>
            </div>

            {/* Decorative elements */}
            <div className="absolute -top-2 -left-2 md:-top-4 md:-left-4 w-4 h-4 md:w-8 md:h-8 bg-orange-300 rounded-full opacity-50"></div>
            <div className="absolute top-1/2 -right-3 md:-right-6 w-3 h-3 md:w-6 md:h-6 bg-red-300 rounded-full opacity-40"></div>

            {/* Mobile authenticity badge */}
            <div className="absolute top-2 left-2 md:top-4 md:left-4 bg-white/90 backdrop-blur-sm rounded-full px-2 py-1 md:px-3 md:py-1 shadow-md lg:hidden">
              <div className="flex items-center space-x-1">
                <CheckCircle className="h-3 w-3 md:h-4 md:w-4 text-green-500" />
                <span className="text-xs md:text-sm font-medium text-gray-700">
                  54th Generation
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Trust Indicators - Mobile Optimized */}
        <div className="mt-8 md:mt-12">
          <div className="bg-gradient-to-r from-orange-50 via-white to-red-50 rounded-xl p-4 md:p-6 border border-orange-100">
            <h3 className="text-lg md:text-xl font-bold text-gray-800 mb-3 md:mb-4 text-center">
              Why Choose Our Authentic Service
            </h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-4">
              <div className="text-center p-3 bg-white rounded-lg border border-gray-100">
                <div className="text-2xl mb-2">🛕</div>
                <div className="font-semibold text-gray-800 text-sm md:text-base">
                  Traditional Methods
                </div>
                <div className="text-xs md:text-sm text-gray-600">
                  Authentic Vedic rituals
                </div>
              </div>
              <div className="text-center p-3 bg-white rounded-lg border border-gray-100">
                <div className="text-2xl mb-2">⭐</div>
                <div className="font-semibold text-gray-800 text-sm md:text-base">
                  Online and Offline Service
                </div>
                <div className="text-xs md:text-sm text-gray-600">
                  Offline service available in Kolhapur
                </div>
              </div>
              <div className="text-center p-3 bg-white rounded-lg border border-gray-100">
                <div className="text-2xl mb-2">🙏</div>
                <div className="font-semibold text-gray-800 text-sm md:text-base">
                  Personal Touch
                </div>
                <div className="text-xs md:text-sm text-gray-600">
                  Direct priest consultation
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PriestSection;
